<template>
  <div class="min-h-screen bg-dashboard-bg">
    <LoginView v-if="!isAuthenticated" @login="onLogin" />
    <ExecutiveDashboard v-else @logout="onLogout" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAuth } from './composables/useAuth.js'
import ExecutiveDashboard from './views/ExecutiveDashboard.vue'
import LoginView from './views/LoginView.vue'

const { user, fetchMe, logout } = useAuth()

const isAuthenticated = computed(() => !!user.value && !!localStorage.getItem('access_token'))

const onLogin = () => {
  fetchMe()
}

const onLogout = () => {
  logout()
}
</script>
